import React, { useEffect, useState } from "react";
import { ResultItem } from "./result-item";
import { Alert, Box } from "@mui/material";
import { axiosInstance } from "../../../services/api/api";
import { RUNNER_STATUS } from "../../../constants/global.constants";
import { useResultsContext } from "../../../services/context/results-context";
import { PropertySection } from "./property-data";
import { sortResultsByName } from "../../../utils/formatting";
import { AlertMessage } from "../../../assets/global/alert/alert-message";
import { LoaderMUI } from "../../../assets/global/loader/loader-mui";

export const ResultList = ({
  resultList,
  selectedResult,
  setSelectedResult,
  selectedRunnerId,
}) => {
  const { runners, setRunners, results, setResults } = useResultsContext();
  /* const [results, setResults] = useState([]); */
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const selectedRunner = runners.find((r) => r.id === selectedRunnerId);

  const getResults = async (runnerId, isFirst) => {
    setError(null);

    try {
      const response = await axiosInstance.get(
        `/runners/getAllResultsForRunner/${runnerId}`,
      );
      const sortedResults = sortResultsByName(response.data.results);
      setResults(sortedResults);
      if (isFirst) {
        setSelectedResult(sortedResults[0]);
      }
    } catch (error) {
      // Handle error
      setError(error.response ? error.response.data.message : error.message);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const getRunnerStatus = async (runnerId) => {
    try {
      const response = await axiosInstance.get(`/runner2/state/${runnerId}`);

      /* setRunnerStatus(response.data.state); */
      setRunners((prev) =>
        prev.map((r) =>
          r.id === runnerId
            ? {
                ...r,
                state: response.data.state,
                total_results: response.data.total,
                completed_results: response.data.completed,
                timings: response.data.timings ?? null,
              }
            : r,
        ),
      );
    } catch (error) {
      // Handle error
      /* setError(error.response ? error.response.data.message : error.message); */
    } finally {
      /* setLoading(false); */
    }
  };

  useEffect(() => {
    if (!selectedRunner?.id || selectedRunner.state === RUNNER_STATUS.SUCCESS)
      return;

    // Only start polling if we have a runner ID and the status is not SUCCESS
    const intervalId = window.setInterval(() => {
      getRunnerStatus(selectedRunner.id);
      getResults(selectedRunnerId, false);
    }, 10000); // 10 seconds

    // Cleanup function to clear the interval
    return () => {
      window.clearInterval(intervalId);
    };
  }, [selectedRunner.state]);

  useEffect(() => {
    setLoading(true);
    getResults(selectedRunnerId, true);
    /* getImage(); */
  }, []);

  /*  if (loading) return <p>Loading results...</p>; */

  return (
    <>
      {/* Error Alert */}
      {error && <AlertMessage message={error} type="error" />}

      <Box
        sx={{
          padding: "0 16px 16px 16px",
          overflowY: "auto",
        }}
        className={"sidebar-results"}
      >
        <PropertySection propertyData={selectedRunner.PropertyData} />
        {loading ? (
          <LoaderMUI withBackdrop={false} />
        ) : (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {results?.length > 0 ? (
              results.map((result, i) => (
                <ResultItem
                  key={result.resultId}
                  index={i}
                  isSelected={selectedResult?.resultId === result.resultId}
                  result={result}
                  setSelectedResult={setSelectedResult}
                />
              ))
            ) : (
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  margin: "0 auto",
                  padding: "0 16px 16px 16px",
                }}
              >
                <Alert
                  severity={"error"}
                  sx={{ width: "100%", fontSize: "12px" }}
                >
                  No results in this generation.
                </Alert>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
